import { render } from "./Modules.vue?vue&type=template&id=3fcf6eef"
import script from "./Modules.vue?vue&type=script&lang=js"
export * from "./Modules.vue?vue&type=script&lang=js"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__